import styled from "styled-components";

const TrailContainer = styled.div``;

export { TrailContainer };
